import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { ProductPageTemplate } from "./ProductPageTemplate";
import { AdminMiniButton } from "../../Components/Admin/AdminMiniButton";
import { Page } from "./Page";
import { BasketProvider } from "../../Services/BasketProvider";
import { PageFooter } from "../Main/PageFooter";


export class ProductPage extends Page
{
    constructor(
        private _shop: ShopContentProvider,
        private _basket: BasketProvider,
        private productUrl: string,
        private optionIdFromUrl: string = "")
    {
        super("specTeam.pl - Produkt");

        this.Append(new PageFooter(_shop));

        this.Content(async (body) =>
        {
            await this._shop.Load();
            // await this._basket.Load();

            const product = this._shop.ProductByUrl(this.productUrl);

            this.SetTitle(product?.Title);

            body.Append(
                this._shop.IsAuthorized && new AdminMiniButton(`product/edit/${product.Url.value}`, "Edytuj produkt"),
                new ProductPageTemplate(product, this._basket.Basket, this.optionIdFromUrl),
            )
        });
    }
}
